/**
 * InvoicePriceTag Component
 */

import './styles.scss';

import * as React from 'react';

import PriceTag, { PriceTagOwnProps } from './';

type InvoicePriceTagProps = Omit<PriceTagOwnProps, 'precision'>;
const InvoicePriceTag = (props: InvoicePriceTagProps) => (
  <PriceTag
    explicitCurrency
    precision={2}
    {...props}
  />
);

export default InvoicePriceTag;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/text/PriceTag/InvoicePriceTag.tsx